import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'accounts.list.pagination', {});
export const getFilters = (state) => get(state, 'accounts.list.filters', {});

export const getAccountsIds = (state) => get(state, 'accounts.list.result.accounts', []);
export const getAccounts = (state) => get(state, 'accounts.list.entities.accounts', {});

export const getIsLoading = (state) => get(state, 'accounts.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'accounts.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'accounts.form.isFetching', false);
export const getIsFetchingConfig = (state) => get(state, 'accounts.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'accounts.form.isSaving', false);
export const getEditing = (state) => get(state, 'accounts.form.editing', false);

export const getVisibleAccounts = createSelector([getAccountsIds, getAccounts], (ids, accounts) =>
  ids.map((id) => accounts[id]).filter((account) => !account.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/selectors/accounts_selectors.js